/** The BFF's API (`/api/*`), with Client view's header (docs/37 §5.9) on every call while it is on. */
export class ApiError extends Error {
  constructor(readonly status: number, readonly code: string, message: string) {
    super(message);
  }
}

const CV_KEY = "station.clientView";
export const clientView = {
  get: (): boolean => { try { return localStorage.getItem(CV_KEY) === "1"; } catch { return false; } },
  set: (on: boolean) => { try { localStorage.setItem(CV_KEY, on ? "1" : "0"); } catch { /* private window */ } },
};

export async function api<T = unknown>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  const res = await fetch(`/api${path}`, {
    method: init.method ?? (init.body !== undefined ? "POST" : "GET"),
    headers: { accept: "application/json", ...(init.body !== undefined ? { "content-type": "application/json" } : {}), ...(clientView.get() ? { "x-client-view": "1" } : {}) },
    ...(init.body !== undefined ? { body: JSON.stringify(init.body) } : {}),
    credentials: "same-origin",
  });
  const text = await res.text();
  const body = text ? JSON.parse(text) : {};
  if (!res.ok) throw new ApiError(res.status, body.error ?? "error", body.message ?? "Something went wrong.");
  return body as T;
}

/** Money in minor units, as the prototype shows it: $4,860 (no cents) unless asked. */
export function money(minor: number | undefined, currency = "USD", cents = false): string {
  if (minor === undefined || Number.isNaN(minor)) return "—";
  const v = minor / 100;
  const sym = currency === "CAD" ? "CA$" : currency === "EUR" ? "€" : "$";
  return `${v < 0 ? "−" : ""}${sym}${Math.abs(v).toLocaleString("en-US", { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: cents ? 2 : 0 })}`;
}

export const fmtDate = (iso: string | undefined, lang = "en") => (iso ? new Date(iso.length === 10 ? `${iso}T12:00:00Z` : iso).toLocaleDateString(lang === "fr" ? "fr-CA" : "en-US", { month: "short", day: "2-digit", year: "numeric", timeZone: "UTC" }) : "");
export const daysUntil = (iso: string | undefined) => (iso ? Math.round((Date.parse(`${iso.slice(0, 10)}T12:00:00Z`) - Date.now()) / 86_400_000) : undefined);
